import React, { useMemo } from "react"

import { FilterChip } from "@/components/common/Filters"
import type { PriceChangeFilterInput, PriceChangeFilterLookupItem } from "@/graphql/codegen/graphql"

interface CategoryFilterChipsProps {
  selectedCategory?: string
  productCategories?: PriceChangeFilterLookupItem[]
  onRemove: (key: keyof PriceChangeFilterInput, value?: string) => void
}

const ProductCategoryFilterChip: React.FC<CategoryFilterChipsProps> = ({
  selectedCategory,
  onRemove,
  productCategories,
}) => {
  const categoryName = useMemo(
    () => productCategories?.find((category) => category.id === selectedCategory)?.label ?? "",
    [selectedCategory, productCategories]
  )

  return (
    <FilterChip
      key='pricing.product-category-filter-chip'
      data-testid='pricing.product-category-filter-chip'
      label={`Product Category: ${categoryName}`}
      onDelete={() => onRemove("productCategoryId", undefined)}
    />
  )
}

export default ProductCategoryFilterChip
